import { PERMISSION_ACTIONS, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import {
  Form,
  Icon,
  ICONS,
  RadioInput,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'src/components/app/app-routes.constants';
import PermissionCheck from 'src/components/permission-check';
import { SETTINGS_PAGES } from 'src/pages/settings/settings.constants';

import { IViewDetailsProps } from './view-details.interfaces';
import { ViewDetailsContainer, IconContainer } from './view-details.styles';

const ViewDetails: FC<IViewDetailsProps> = ({ record, removeGroup }) => {
  const navigate = useNavigate();
  const { t } = useTranslation('settings');

  return (
    <ViewDetailsContainer>
      <Form layout="vertical">
        {record.permissions.map(({ permission, rule }: any) => (
          <Form.Item
            key={permission}
            label={t(`permissionGroupSettings.planWerkPermissions.${permission}`)}
          >
            <RadioInput disabled checked>
              {t(`permissionGroupSettings.rules.${rule}`)}
            </RadioInput>
          </Form.Item>
        ))}
      </Form>
      {record.name !== 'Admin' && (
        <IconContainer canDelete>
          <PermissionCheck
            action={PERMISSION_ACTIONS.update}
            permission={PLATFORM_PERMISSIONS.permissionGroup}
          >
            <Icon
              icon={ICONS.editAlt}
              size={22}
              color={PLATFORM_THEME_COLORS.primary.grey}
              onClick={() =>
                navigate({
                  pathname: `${ROUTES.settings}?type=${SETTINGS_PAGES.permissionGroupsEdit}&id=${record._id}`,
                })
              }
            />
          </PermissionCheck>
          <PermissionCheck
            action={PERMISSION_ACTIONS.delete}
            permission={PLATFORM_PERMISSIONS.permissionGroup}
          >
            <Icon
              icon={ICONS.trash}
              color={PLATFORM_THEME_COLORS.tone.red}
              size={22}
              onClick={() => removeGroup(record._id)}
            />
          </PermissionCheck>
        </IconContainer>
      )}
    </ViewDetailsContainer>
  );
};

export default ViewDetails;
